import { BaseQueryFn } from '@reduxjs/toolkit/dist/query'
import { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes'
import { MaybePromise } from '@reduxjs/toolkit/dist/query/tsHelpers'
import {
    useLazySelectCacheInfoQuery,
    useLazySelectCom0102Query,
} from 'app/core/services/com/com.service'
import {
    commonProgressDialog,
    useProgressDialog,
} from 'app/shared/context/CommonUIProvider'
import React from 'react'

export interface CommonCodeProps {
    /** 배포대상 코드키
     * @description UIBMAO_001    공지알림
     * @description UIBMAO_003    배너
     * @description UIBMAO_004    이벤트
     * @description UIBMAO_005    영업점정보
     * @description UIBMAO_006    영업점배너
     * @description UIBMAO_007    제휴사동의서
     * @description UIBMAO_008    추천상품
     * @description UIBMAO_109    상품정보
     * @description UIBMAO_110    공통코드
     * @description UIBMAO_111    상품별거래제어
     * @description UIBMAO_112    사용자메뉴
     * @description UIBMAO_113    일자전환체크
     */
    dsrnTgtBacd: string

    /**
     * 코드그룹ID
     * @description WTCNS_URL_ADR 상품약관
     */
    cdgpId: string

    /** 코드ID
     */
    ccddId?: string

    /**
     * @default True
     */
    fetchOnLoad?: boolean
    /**
     * @default False
     */
    skipProgress?: boolean
}

export interface WtcnsUrlAdr {
    cdgpId: string //'WTCNS_URL_ADR'
    ccddId: string //'TERM-001'
    cdNm: string //'개인정보 조회에 관한 사항'
    descCon: string //''
    expuSqc: number //1
    prnsId: string //''
    cdAtrbEtc1Con: string //'/com/agm/TERM001'
    cdAtrbEtc2Con: string //'HTML'
    cdAtrbEtc3Con: string //'M'
    cdAtrbEtc4Con: string //''
    cdAtrbEtc5Con: string //''
}

export interface DateConversionInfo {
    data: {
        sttgHms: string //"121212",
        fnshHms: string //"180000",
        rvctHms: string //"",
        gdncMsgCon: string //"죄송합니다.&lt;br /&gt;온라인 전환 및 시스템 조정작업으로&lt;br /&gt;일시중지 중 이오니&lt;br /&gt;잠시 후 이용하여 주시기 바랍니다.&lt;br /&gt;&lt;br /&gt;시스템 전환일시 : 매일 00시 00분 ~ 00시 10분&lt;br /&gt;(시스템 사정에 따라 중지 시간은&lt;br /&gt;변경 될 수 있습니다.)",
        fnsgYn: string //"N"
    }
}

/**
 * 각 코드키의 OUTPUT Interface는 generic으로 넣어주어야 한다
 */
export const useCommonCode = <T = any>(props) => {
    const {
        dsrnTgtBacd,
        cdgpId,
        ccddId,
        fetchOnLoad = true,
        skipProgress = false,
    } = props

    const [fetch0102, { data, isLoading, isFetching }] =
        useLazySelectCacheInfoQuery()

    const { show: showLoadingDialog, hide: hideLoadingDialog } =
        useProgressDialog()

    // React.useEffect(() => {
    //     if (!skipProgress) {
    //         if (!data && isLoading && isFetching) {
    //             showLoadingDialog()
    //         } else {
    //             hideLoadingDialog()
    //         }
    //     }
    // }, [isLoading, isFetching, data])

    React.useEffect(() => {
        ;(async () => {
            if (fetchOnLoad) {
                if (!skipProgress) {
                    showLoadingDialog()
                }
                await fetch0102({
                    dsrnTgtBacd: dsrnTgtBacd,
                    ccddId: ccddId,
                    cdgpId: cdgpId,
                })

                if (!skipProgress) {
                    hideLoadingDialog()
                }
            }
        })()
    }, [])

    const trigger = () => {
        if (!skipProgress) {
            showLoadingDialog()
        }
        fetch0102({
            dsrnTgtBacd: dsrnTgtBacd,
            ccddId: ccddId,
            cdgpId: cdgpId,
        }).finally(() => {
            if (!skipProgress) {
                hideLoadingDialog()
            }
        })
    }

    const fetchCommonCode = () => {
        if (!skipProgress) {
            showLoadingDialog()
        }
        return fetch0102({
            dsrnTgtBacd: dsrnTgtBacd,
            ccddId: ccddId,
            cdgpId: cdgpId,
        }).finally(() => {
            if (!skipProgress) {
                hideLoadingDialog()
            }
        })
    }

    return {
        data: data as unknown as T,
        trigger: trigger,
        fetchCommonCode: fetchCommonCode,
    }
}
